import React, { useState } from 'react';
import ImageModal from './ImageModal';
import { ZoomIn } from 'lucide-react';

interface ExpandableImageProps {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
  showZoomIcon?: boolean;
}

const ExpandableImage: React.FC<ExpandableImageProps> = ({
  src,
  alt,
  className = '',
  containerClassName = '',
  showZoomIcon = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={`relative group cursor-pointer ${containerClassName}`}
        onClick={() => setIsModalOpen(true)}
      >
        <img
          src={src}
          alt={alt}
          className={`transition-all duration-300 ${className}`}
        />

        {/* Zoom icon overlay */}
        {showZoomIcon && (
          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-deep-space rounded-full p-3 shadow-lg">
              <ZoomIn className="w-6 h-6 text-white" />
            </div>
          </div>
        )}
      </div>

      <ImageModal
        src={src}
        alt={alt}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ExpandableImage;
